
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2nJpt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c9500938c916b74b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $c9500938c916b74b$export$2e2bcd8739ae039 = {
    'editorExtensionLinkCreate.confluencePage.newDraftTitle': "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0431\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F",
    'editorExtensionLinkCreate.confluencePage.quickInsert.description': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438 \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0435\u0435 \u043A\u0430\u043A \u0441\u0441\u044B\u043B\u043A\u0443",
    'editorExtensionLinkCreate.confluencePage.quickInsert.title': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 Confluence",
    'editorExtensionLinkCreate.confluencePage.successFlag.action.open': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0432 Confluence",
    'editorExtensionLinkCreate.confluencePage.successFlag.description': "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0430",
    'editorExtensionLinkCreate.confluencePage.successFlag.title': "\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0430",
    'editorExtensionLinkCreate.confluencePage.title': "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B",
    'editorExtensionLinkCreate.genericError.description': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443.",
    'editorExtensionLinkCreate.genericError.title': "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430",
    'editorExtensionLinkCreate.jiraIssue.quickInsert.description': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0443\u044E \u0437\u0430\u0434\u0430\u0447\u0443 \u0438 \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0435\u0435 \u043A\u0430\u043A \u0441\u0441\u044B\u043B\u043A\u0443",
    'editorExtensionLinkCreate.jiraIssue.quickInsert.title': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0443 Jira",
    'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0432 Jira",
    'editorExtensionLinkCreate.jiraIssue.successFlag.description': "\u0417\u0430\u0434\u0430\u0447\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0430",
    'editorExtensionLinkCreate.jiraIssue.successFlag.title': "\u0417\u0430\u0434\u0430\u0447\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0430",
    'editorExtensionLinkCreate.jiraIssue.title': "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438",
    'editorExtensionLinkCreate.keyword.create': "\u0441\u043E\u0437\u0434\u0430\u0442\u044C",
    'editorExtensionLinkCreate.keyword.issue': "\u0437\u0430\u0434\u0430\u0447\u0430",
    'editorExtensionLinkCreate.keyword.new': "\u043D\u043E\u0432\u044B\u0439",
    'editorExtensionLinkCreate.keyword.page': "\u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
    'editorExtensionLinkCreate.keyword.publish': "\u043E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u0442\u044C",
    'editorExtensionLinkCreate.keyword.raise': "\u0441\u043E\u0437\u0434\u0430\u0442\u044C",
    'editorExtensionLinkCreate.keyword.space': "\u0440\u0430\u0437\u0434\u0435\u043B",
    'editorExtensionLinkCreate.keyword.ticket': "\u0437\u0430\u044F\u0432\u043A\u0430"
};

});


//# sourceMappingURL=ru.c7233352.js.map
